import React from 'react';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import FieldsSelect from '../common/FieldsSelect';
import { extractMetaFor } from '../../utils/filter';
import { prepareDropdown } from '../../utils/common';
import { filterClauseExcludeFields } from '../../constants/metainf';
import ValueSelectorContainer from './ValueSelectorContainer';

const FilterClause = ({
  field,
  operator,
  value,
  metainf,
  zoneId,
  onRemove,
  onSelectField,
  onSelectOperator,
  onValueChange,
  excludeGroups = [],
}) => {
  const fieldMeta = extractMetaFor(field, metainf);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        margin: '0 10px 10px 0',
        maxWidth: '92%',
      }}
    >
      <div style={{ display: 'inline-block', flexShrink: 0, marginRight: 10 }}>
        <Button
          className="square-icon-button"
          onClick={() => onRemove()}
          style={{ border: '1px solid transparent' }}
        >
          <DeleteOutlined />
        </Button>
      </div>
      <FieldsSelect
        value={field}
        fields={prepareDropdown(metainf, false, filterClauseExcludeFields.concat(excludeGroups))}
        onSelect={(fieldParam) =>
          onSelectField(fieldParam, extractMetaFor(fieldParam, metainf).type)
        }
        style={{ width: 145, flexShrink: 0 }}
      />
      {field && (
        <ValueSelectorContainer
          onSelectOperator={(valueParam, resetValue) => onSelectOperator(valueParam, resetValue)}
          onValueChange={(valueParam) => onValueChange(valueParam)}
          render={!!field}
          operator={operator}
          value={value}
          meta={fieldMeta}
          zoneId={zoneId}
          style={{ maxWidth: 'calc(100% - 200px)' }}
        />
      )}
    </div>
  );
};

export default FilterClause;
